export default {
    request: {
        headers: {
            request_information: 'General information',
            workConditions: 'Working conditions',
            hr_manager: 'HR-manager',
            basicInformation: 'General information',
            requirementsForCandidate: 'Requirements for a candidate',
            position: 'Position',
            status: 'Status',
            responsibleName: 'HR-manager',
            quantity: 'Quantity',
            timePassed: 'Sent',
            date: 'Sent on'
        },
        add: 'Send Request',
        company: 'Company',
        organization: 'Company',
        department: 'Department',
        position: 'Position',
        town: 'Town',
        quantity: 'Quantity',
        reason: 'Reason of Opening',
        replacing: 'Replaced Employee',
        deadline: 'Close Before',
        salary: 'Salary min-max',
        bonuses: 'Compensations and Benefits',
        probation: 'Probation, days',
        requirements: 'Experience Requirements',
        age: {
            title: 'Age',
            value: 'y/o'
        },
        experience: 'Yrs of Exp.',
        education: 'Education',
        educationComment: 'Education’s comment',
        responsibilities: 'Responsibilities',
        personalQualities: 'Personal Qualities',
        from: 'from',
        up_to: 'up to',
        gross: 'Before taxation',
        net: 'After taxation',
        workplace: 'Employer',
        schedule: 'Work Schedule',
        workType: 'Employment Type',
        budget: 'Presence in the Budget',
        result: 'Result',
        responsible: 'Full name',
        sex: 'Sex',
        comment: 'Additional Information',
        status: 'Status',
        legal: 'Legal entity',
        legalRoute: 'Find employee',
        legalRoutes: {
            current: 'Position exist',
            new: 'New position',
        },
        legalCell: 'Cell of Staff Schedule',
        legalExplanation: 'Explanation',
        legalCellOptions: 'Properties of staff schedule cell code',
        cellsMode: 'Search by cell name ',
        employeesMode: 'Search by employee name',
        legalCellGrade: 'Grade',
        legalCellNumrates: 'Free rates',
        legalDepartment: 'Node of the organizational structure',
        legalRole: 'Role in the organizational structure',
        legalChief: 'Who is submitting for',
        legalRoleChief: 'Manager',
        legalRoleReplace: 'Submits requests on behalf of the manager',
        legalError: 'You cannot send requests because you are not linked to the node of the organizational structure in Experium. <br /> Contact your HR department employees, as only they have the authority to link employees to the nodes of the organizational structure.',
    }
};
